'use client';

import type { ReactNode } from 'react';
import cx from 'clsx';

type Props = {
  title?: ReactNode;
  description?: ReactNode;
  imageUrl?: string;
  imageSize?: string | number;
  action?: ReactNode;
  className?: string;
};

export function Signage({
  title,
  description,
  action,
  imageUrl,
  imageSize,
  className,
}: Props) {
  return (
    <>
      <div
        className={cx(
          'flex items-center justify-center h-[calc(100vh_-_60px)] flex-col px-20 text-center',
          className,
        )}
      >
        {imageUrl && <img src={imageUrl} alt="signage" width={imageSize} />}
        {title && (
          <span className="text-gray-1000 typo-title100-semibold">{title}</span>
        )}
        {description && (
          <span className="mt-4 whitespace-pre-line break-all text-gray-800 typo-paragraph100-regular">
            {description}
          </span>
        )}
        {action && <div className="mt-16 flex justify-center">{action}</div>}
      </div>
    </>
  );
}
